import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TariffElementService {
    baseUrl = '/api/secured/tariff-element';

    constructor(private http: HttpClient) {
    }

    uploadFile(hash) {
        return this.http.post(`${this.baseUrl}/import?hash=${hash}`, {});
    }

    downloadFile() {
        window.location.href = `${this.baseUrl}/download`;
    }

    getDate() {
        return this.http.get<string>(`${this.baseUrl}/date`);
    }

}
